module.exports = __webpack_public_path__ + "img/11.2338e1ea.jpg";